<template>
  <el-row id="caregiver-card">
    <el-row class="section">
      <div class="present-profile-container">
        <div class="present-profile-left">
          <div class="avatar-container">
            <div class="circle">
              <img class="fit" v-if="caregiverData.photo" :src="caregiverData.photo" width="200px" height="200px">
              <img v-else src="@/assets/avatar@3x.png" width="200px" height="200px">
            </div>
            <div
                class="header-24-white-center ellipsis"
                style="margin-top: 20px;">{{ fullname }}
            </div>
          </div>
          <div class="data-container">
            <div class="box">
              <div class="title">เพศ</div>
              <div class="data">{{ caregiverData.gender }}</div>
            </div>
            <div class="box">
              <div class="title">อายุ</div>
              <div class="data">{{ caregiverData.age }} ปี</div>
            </div>
            <div class="box">
              <div class="title">สัญชาติ</div>
              <div class="data">{{ caregiverData.nationality }}</div>
            </div>
            <div class="box">
              <div class="title">น้ำหนัก</div>
              <div class="data">{{ caregiverData.weight }} กก.</div>
            </div>
            <div class="box">
              <div class="title">ส่วนสูง</div>
              <div class="data">{{ caregiverData.height }} ซม.</div>
            </div>
          </div>
        </div>
        <div class="present-profile-right">
          <div class="box">
            <div class="title-label"><img src="@/assets/icon/user-stroke-white.svg" width="20px" height="20px">
              <div class="title">ประเภทผู้ดูแล</div>
            </div>
            <div class="data" style="margin-left: 40px;">{{ caregiverData.publicType }}</div>
          </div>
          <div class="box" style="margin-top: 20px;">
            <div class="title-label"><img src="@/assets/icon/plus-sign-stroke-white.svg" width="20px" height="20px">
              <div class="title">ทักษะการดูแล</div>
            </div>
            <div class="box" style="margin-left: 40px; margin-top: 10px;">
              <div class="data" v-for="skill in skills"><img src="@/assets/icon/tick.svg" width="20px" height="20px;">&ensp; {{ skill }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="logo-container">
        <div class="hah-information">www.healthathome.in.th <br> 02-080-3936</div>
        <img src="@/assets/hah-logo-caregiver-card.png" width="99px" height="31px" style="margin-top: 6px;" >
      </div>
    </el-row>
  </el-row>
</template>

<style lang="scss" scoped>
  .mainContainer {
    padding: 20px 100px 100px;
  }

  .circle {
    border-radius: 100%;
    height: 200px;
    width: 200px;
    justify-content: center;
    overflow: hidden;
    margin-top: 40px;
    margin-left: 40px;
  }

  .fit {
    object-fit: cover;
  }

  .ellipsis {
    font-family: 'Sukhumvit-Bold';
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 400px;
  }

  .header-24-white-center {
    color: white;
    font-size: 24px;
    text-align: center;
  }
  .title-label {
    display: flex;
    flex-direction: row;
    width: 100px;
    justify-content: space-between;
  }

  .avatar-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .present-profile-container {
    margin-top: 40px;
    height: 700px;
    width: 100%;

    display: flex;
    flex-direction: row;
  }

  .logo-container {
    width: 100%;
    height: 60px;
    padding: 8px 24px 0 24px;
    background-color: #7FA7FF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .present-profile-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #3970EA;
    padding: 50px;
    width: 50%;
    height: 100%;
  }

  .hah-information {
    color: #ffffff;
    font-size: 14px;
    opacity: 0.8;
    font-style: normal;
    font-stretch: normal;
    font-weight: bold;
  }

  .present-profile-right {
    background-color: #5489FF;
    width: 50%;
    height: 100%;

    padding: 70px;
    padding-left: 100px;
  }

  .section {
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
  }

  .data-container {
    margin-top: 30px;

    color: white;

    display: grid;
    grid-template-columns: repeat(3, 100px);
    grid-template-rows: repeat(2, auto);
    grid-row-gap: 20px;
    grid-column-gap: 40px;
  }

  .box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .title {
    font-family: 'Sukhumvit-Light';
    font-size: 12px;
    font-weight: 200;
    color: white;
  }

  .data {
    font-size: 18px;
    color: white;
  }

  .right {
    text-align: right;
  }
</style>

<script>
export default {
  props: {
    caregiverData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    skills () {
      return this.caregiverData.skillsDisplayable
    },
    fullname () {
      return `${this.caregiverData.nickName} ( ${this.caregiverData.name} )`
    },
  },
}
</script>
